<p-dialog
  data-testid="add-property-dialog"
  [(visible)]="visible"
  [modal]="true"
  [style]="{ width: '55rem' }"
  [header]="
    (viewMode
      ? 'goods.spu.actions.view_property'
      : 'goods.spu.actions.add_property'
    ) | translate
  "
  (onHide)="onCancel()"
>
  <div class="px-4 min-h-[350px]" [class.view-mode-container]="viewMode">
    <!-- Basic Information Section -->
    <h2 class="font-medium text-lg mb-3">
      {{ "goods.spu.attributes.basic_information" | translate }}
    </h2>
    <form
      data-testid="add-property-dialog-form"
      [formGroup]="propertyForm"
      class="grid grid-cols-2 gap-4 items-start"
      [class.pointer-events-none]="viewMode"
    >
      <!-- Property Name -->
      <div>
        <label
          for="add-property-name"
          class="block text-sm font-medium text-gray-700 mb-1"
        >
          {{ "goods.spu.attributes.fields.property_name" | translate }}
          <span class="text-red-500">*</span>
        </label>
        <input
          data-testid="add-property-dialog-name-input"
          pInputText
          id="add-property-name"
          formControlName="name"
          class="w-full"
          [placeholder]="
            'goods.spu.attributes.placeholders.enter_property_name' | translate
          "
          [disabled]="viewMode"
        />
        @if (
          propertyForm.get("name")?.errors?.['required'] && propertyForm.get("name")?.touched
        ) {
          <small class="block mt-1 text-xs text-red-500">
            {{
              "goods.spu.attributes.validation.property_name_required"
                | translate
            }}
          </small>
        }
        @if (propertyForm.get("name")?.errors?.['maxlength']) {
          <small class="block mt-1 text-xs text-red-500">
            {{ 'common.validation.maxlength' | translate: maxLengthParams('goods.spu.attributes.fields.property_name', 255) }}
          </small>
        }
      </div>

      <!-- Property Code -->
      <div>
        <label
          for="add-property-code"
          class="block text-sm font-medium text-gray-700 mb-1"
        >
          {{ "goods.spu.attributes.fields.property_code" | translate }}
        </label>
        <input
          data-testid="add-property-dialog-code-input"
          pInputText
          id="add-property-code"
          formControlName="code"
          class="w-full"
          [placeholder]="
            'goods.spu.attributes.placeholders.enter_property_code' | translate
          "
          [disabled]="viewMode"
        />
        @if (propertyForm.get("code")?.errors?.['maxlength']) {
          <small class="block mt-1 text-xs text-red-500">
            {{ 'common.validation.maxlength' | translate: maxLengthParams('goods.spu.attributes.fields.property_code', 255) }}
          </small>
        }
      </div>

      <!-- Display Type -->
      <div>
        <label
          for="add-property-display-type"
          class="block text-sm font-medium text-gray-700 mb-1"
        >
          {{ "goods.spu.attributes.fields.display_type" | translate }}
          <span class="text-red-500">*</span>
        </label>
        <p-select
          data-testid="add-property-dialog-display-type-select"
          inputId="add-property-display-type"
          formControlName="submissionsType"
          [options]="displayTypeOptions"
          optionLabel="label"
          optionValue="value"
          [placeholder]="
            'goods.spu.attributes.placeholders.select_display_type' | translate
          "
          class="w-full"
          [disabled]="viewMode"
          (onChange)="onDisplayTypeChange()"
        ></p-select>
        @if (
          propertyForm.get("submissionsType")?.invalid &&
          propertyForm.get("submissionsType")?.touched
        ) {
          <small class="block mt-1 text-xs text-red-500">
            {{
              "goods.spu.attributes.validation.display_type_required"
                | translate
            }}
          </small>
        }
        <small class="text-gray-500 text-xs mt-1 block">
          {{
            "goods.spu.attributes.help_text.display_types_require_values"
              | translate
          }}
        </small>
      </div>

      <!-- Remarks -->
      <div class="form-field">
        <label
          for="add-property-remark"
          class="block text-sm font-medium text-gray-700 mb-1"
        >
          {{ "goods.spu.attributes.fields.remarks" | translate }}
        </label>
        <input
          data-testid="add-property-dialog-remark-input"
          pInputText
          id="add-property-remark"
          formControlName="remark"
          class="w-full text-sm"
          [placeholder]="
            'goods.spu.form.placeholders.enter_remarks' | translate
          "
          [disabled]="viewMode"
        />
        @if (propertyForm.get("remark")?.errors?.['maxlength']) {
          <small class="block mt-1 text-xs text-red-500">
            {{ 'common.validation.maxlength' | translate: maxLengthParams('goods.spu.attributes.fields.remarks', 255) }}
          </small>
        }
      </div>

      <!-- Generate SKU -->
      @if (!hideGenerateSku) {
        <div class="flex items-center col-span-2">
          <p-checkbox
            data-testid="add-property-dialog-generate-sku-checkbox"
            formControlName="generateSku"
            inputId="add-property-generate-sku"
            [binary]="true"
            [disabled]="viewMode || showTextValueInput()"
          ></p-checkbox>
          <label
            for="add-property-generate-sku"
            class="ml-2 text-sm font-medium text-gray-700"
            >{{ "goods.spu.attributes.fields.generate_sku" | translate }}</label
          >
        </div>
      }
    </form>

    @if (showTextValueInput()) {
      <p-divider class="mt-4">
        <span class="font-medium">{{
          "goods.spu.attributes.information_content" | translate
        }}</span>
      </p-divider>

      <div class="mt-2 form-field">
        <label
          for="add-property-text-value"
          class="block text-sm font-medium text-gray-700 mb-1"
        >
          {{ "goods.spu.attributes.fields.property_values" | translate }}
        </label>
        <textarea
          data-testid="add-property-dialog-text-value-input"
          pTextarea
          id="add-property-text-value"
          class="w-full text-sm"
          rows="3"
          [value]="getTextBoxValue()"
          [placeholder]="
            'goods.spu.attributes.placeholders.enter_property_value'
              | translate
          "
          [disabled]="viewMode"
          (input)="onTextBoxValueChange($event)"
        ></textarea>
      </div>
    }

    <!-- Information Content Section (Conditional) -->
    @if (showValueTable()) {
      <p-divider class="mt-4">
        <span class="font-medium">{{
          "goods.spu.attributes.information_content" | translate
        }}</span>
      </p-divider>

      <div class="mt-2 overflow-x-hidden">
        @if (!viewMode) {
          <div class="flex gap-2 mb-4">
            <app-button
              [testId]="'add-property-dialog-delete-selected-values-btn'"
              [label]="'common.actions.delete' | translate"
              type="danger"
              [outlined]="true"
              [disabled]="selectedValues().length === 0"
              (emitOnClick)="onDeleteSelectedValues()"
            ></app-button>
            <app-button
              [testId]="'add-property-dialog-add-value-btn'"
              [label]="'common.actions.add' | translate"
              type="info"
              (emitOnClick)="onAddValue()"
            ></app-button>
          </div>
        }

        <app-data-table
          data-testid="add-property-dialog-values-table"
          [dataSource]="propertyValues()"
          [columns]="valueTableColumns"
          [rows]="10"
          [first]="0"
          [totalRecords]="propertyValues().length"
          [loading]="false"
          [selection]="selectedValues()"
          [hasCheckColumn]="!viewMode"
          (selectionChange)="onValueSelectionChange($event)"
          [rowsPerPageOptions]="[5, 10, 20, 50]"
          [scrollHeight]="'270px'"
          [style]="{ 'overflow-x': 'hidden' }"
        >
          <!-- Custom Property Value Template -->
          <ng-template
            #customTemplate
            let-rowData="rowData"
            let-column="column"
          >
            @if (column?.prop === "value" && rowData.isEditing && !viewMode) {
              <input
                [attr.data-testid]="'add-property-dialog-value-input-' + rowData.id"
                pInputText
                [value]="rowData.value"
                (input)="onInputChange(rowData, $event)"
                class="w-full p-1 border border-gray-300 rounded text-xs"
                [placeholder]="
                  'goods.spu.attributes.placeholders.enter_property_value'
                    | translate
                "
                #inputRef
              />
            } @else if (column?.prop === "value") {
              <span class="text-xs">{{ rowData.value }}</span>
            } @else if (
              column?.prop === "asset" && rowData.isEditing && !viewMode
            ) {
              <p-select
                [attr.data-testid]="'add-property-dialog-asset-select-' + rowData.id"
                [options]="getAssetOptions()"
                [ngModel]="rowData.asset"
                (ngModelChange)="onAssetChange(rowData, $event)"
                (onShow)="onDropdownShow()"
                (onHide)="onDropdownHide()"
                optionLabel="label"
                optionValue="value"
                [placeholder]="
                  'goods.spu.attributes.placeholders.select_asset_image'
                    | translate
                "
                class="w-full asset-select"
                [ngModelOptions]="{ standalone: true }"
                [disabled]="viewMode"
                [showClear]="!!rowData.asset"
                appendTo="body"
                panelStyleClass="asset-dropdown-panel"
                [virtualScroll]="false"
                [filter]="false"
              >
                <ng-template pTemplate="item" let-option>
                  <div class="flex items-center gap-2 p-2">
                    @if (option.image) {
                      <img
                        [src]="option.image"
                        [alt]="option.originalName"
                        class="asset-image"
                        (error)="onImageError($event)"
                      />
                    }
                    <span class="asset-label">{{ option.label }}</span>
                  </div>
                </ng-template>
                <ng-template pTemplate="selectedItem" let-selectedOption>
                  <div class="flex items-center gap-2 w-full">
                    @if (selectedOption?.image) {
                      <img
                        [src]="selectedOption.image"
                        [alt]="selectedOption.originalName"
                        class="asset-image-small"
                        (error)="onImageError($event)"
                      />
                    }
                    <span class="asset-label">{{ selectedOption?.label }}</span>
                  </div>
                </ng-template>
              </p-select>
            } @else if (column?.prop === "asset") {
              @if (rowData.asset) {
                @if (getSelectedAssetInfo(rowData.asset); as assetInfo) {
                  <div class="flex items-center gap-2 w-full">
                    @if (assetInfo.image) {
                      <img
                        [src]="assetInfo.image"
                        [alt]="assetInfo.originalName"
                        class="asset-image"
                        (error)="onImageError($event)"
                      />
                    }
                    <span class="asset-label">{{ assetInfo.label }}</span>
                  </div>
                } @else {
                  <span class="text-sm text-gray-500">{{
                    "goods.spu.attributes.validation.invalid_asset" | translate
                  }}</span>
                }
              } @else {
                <span class="text-sm text-gray-400">{{
                  "goods.spu.attributes.validation.no_asset_selected"
                    | translate
                }}</span>
              }
            }
          </ng-template>

          <!-- Custom Actions Template -->
          <ng-template #actionsTemplate let-rowData>
            @if (!viewMode) {
              <div class="actions-container flex justify-center gap-2">
                @if (rowData.isEditing) {
                  <app-button
                    [testId]="'add-property-dialog-action-save-' + rowData.id"
                    type="action"
                    [label]="'common.actions.save' | translate"
                    class="action-save"
                    (emitOnClick)="onSaveValue(rowData.id)"
                  ></app-button>
                  <app-button
                    [testId]="'add-property-dialog-action-cancel-' + rowData.id"
                    type="action"
                    [label]="'common.actions.cancel' | translate"
                    class="action-cancel"
                    (emitOnClick)="onCancelEdit(rowData.id)"
                  ></app-button>
                } @else {
                  <app-button
                    [testId]="'add-property-dialog-action-edit-' + rowData.id"
                    type="action"
                    [label]="'common.actions.edit' | translate"
                    class="action-edit"
                    (emitOnClick)="onEditValue(rowData.id)"
                  ></app-button>
                  <app-button
                    [testId]="'add-property-dialog-action-delete-' + rowData.id"
                    type="action"
                    [label]="'common.actions.delete' | translate"
                    class="action-delete"
                    (emitOnClick)="onDeleteValue(rowData.id)"
                  ></app-button>
                }
              </div>
            }
          </ng-template>
        </app-data-table>
      </div>
    }
  </div>

  <ng-template pTemplate="footer">
    <div class="flex justify-end gap-2">
      @if (!viewMode) {
        <app-button
          [testId]="'add-property-dialog-cancel-btn'"
          [label]="'common.actions.cancel' | translate"
          type="secondary"
          [outlined]="true"
          (emitOnClick)="onCancel()"
        ></app-button>
        <app-button
          [testId]="'add-property-dialog-confirm-btn'"
          [label]="'common.actions.confirm' | translate"
          type="info"
          [disabled]="propertyForm.invalid"
          (emitOnClick)="onConfirm()"
        ></app-button>
      } @else {
        <app-button
          [testId]="'add-property-dialog-close-btn'"
          [label]="'common.actions.close' | translate"
          type="secondary"
          [outlined]="true"
          (emitOnClick)="onCancel()"
        ></app-button>
      }
    </div>
  </ng-template>
</p-dialog>
